document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function(){
  const productCards = document.querySelector(".Product__Info");
    const optionWidget = productCards.querySelector(".rc-widget");
    const onetimeOption = optionWidget?.querySelector(".onetime-radio");
    const subscriptionOption = optionWidget?.querySelector(".subscription-radio");
    const toggleOneTime = productCards.querySelector(".pt_413_toggle_input_one_time");
    const toggleSubscription = productCards.querySelector(".pt_413_toggle_input_subscription");
    const onetimeWrapper = productCards.querySelector(".pt_413_onetime_wrapper");
    const subscriptionWrapper = productCards.querySelector(".pt_413_subscription_wrapper");
    const onetimeLeftLowerCTA = productCards.querySelector(".pt_413_onetime_left_lower_cta");
    
    if (!optionWidget) return;
     
    toggleOneTime?.addEventListener("click", function () {
      subscriptionOption?.click();
      onetimeWrapper?.classList.add("pt_413_hidden");
      subscriptionWrapper?.classList.remove("pt_413_hidden");
      productCards.querySelector(".bfcm-banner-pdp")?.classList.remove("pt_413_hidden");
      const subscriptionPrice = subscriptionOption?.getAttribute("optionprice"); // Get the price from option
    });
    
    toggleSubscription?.addEventListener("click", function () {
      onetimeOption?.click();
      subscriptionWrapper?.classList.add("pt_413_hidden");
      onetimeWrapper?.classList.remove("pt_413_hidden");
      productCards.querySelector(".bfcm-banner-pdp")?.classList.add("pt_413_hidden");
      const oneTimePrice = onetimeOption?.getAttribute("optionprice"); // Get the price from option
    });
    onetimeLeftLowerCTA?.addEventListener("click", function () {
      subscriptionOption?.classList.add("PT242__OptionWidget--Active");
      onetimeOption?.classList.remove("PT242__OptionWidget--Active");

      onetimeWrapper?.classList.add("pt_413_hidden");
      subscriptionWrapper?.classList.remove("pt_413_hidden");
      productCards.querySelector(".bfcm-banner-pdp")?.classList.remove("pt_413_hidden");
      const subscriptionPrice = subscriptionOption?.getAttribute("optionprice"); // Get the price from option
    });
  }, 1000);
});